import { useEffect, useState } from "react";
import { doPostMessage } from "../utils/rn";
import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';
import { questionGenerate } from "../utils/questionUtils";
import Option from "../components/Option";
import { getOptionsFromData } from "../utils/question";

const pt = console.log

const test = () => {
    // console.log(transpose('C5', '-1P'))
    // console.log(Note.simplify('Dbbb4'))
    // pt(Interval.get(distance('D', 'C')))
}

test();

const QuestionSelection = () => {
    const question_type = localStorage.getItem('question_type') || 'SelectionYinCheng';

    const [options, setOptions] = useState<{ [key: string]: string[] | string[][] }>({});
    const [correctOpt, setCorrectOpt] = useState<string>('');
    const [questionIndex, setQuestionIndex] = useState<number>(1);
    const [initChoose, setInitChoose] = useState<string>('');
    const [viewOnly, setViewOnly] = useState<boolean>(false);

    const createQuestion = () => {
        const questionType = localStorage.getItem('question_type') ?? '';
        const dataJson: any = questionGenerate(questionType);

        doPostMessage(questionType, 'debug');

        initStave(dataJson);
        setQuestionIndex(questionIndex + 1);

        return dataJson;
    }

    useEffect(() => {
        doPostMessage('', 'loaded');

        const viewportMeta = document.querySelector('meta[name="viewport"]');
        viewportMeta?.setAttribute("content", "width=device-width, initial-scale=0.6, user-scalable=no");
    }, []);

    const initStave = (data: any) => {
        localStorage.setItem('question_selection_key', data.key || 'C');
        const _options = getOptionsFromData(data, question_type);
        setOptions(_options);
        setCorrectOpt(data.choose);
        const msg = { ...data, options: _options };
        doPostMessage(msg, 'create_question');
    };

    const viewQuestion = () => {
        const questionType = localStorage.getItem('question_type') ?? '';
        const config: any = JSON.parse(localStorage.getItem('question_config') ?? '{}');
        const dataJson: any = config;

        initStave(dataJson);
        const userAnswer = localStorage.getItem('question_user_answer');
        setInitChoose(userAnswer || '');

        const vo = localStorage.getItem('view_only') === '1';
        setViewOnly(vo);
        setQuestionIndex(questionIndex + 1);

        return dataJson;
    }

    const revertQuestion = () => {

        try {
            const jsonString = localStorage.getItem('question_config') ?? '';
            const dataJson: any = JSON.parse(jsonString);

            initStave(dataJson);
            setInitChoose('');
            setQuestionIndex(questionIndex + 1)

            const vo = localStorage.getItem('view_only') === '1';
            setViewOnly(vo);

            return dataJson;
        } catch (e) {
            doPostMessage({ e }, 'debug');
        }
    };

    return (
        <>
            <div id="generateQuestion" onClick={() => createQuestion()} />
            <div id="viewQuestion" onClick={() => viewQuestion()} />
            <div id="revertQuestion" onClick={() => revertQuestion()} />
            <Option initChoose={initChoose} viewOnly={viewOnly} config={options} question_type={question_type} correctOpt={correctOpt} questionIndex={questionIndex} />
        </>
    );
};

export default QuestionSelection
